import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { InternalTaskBoard } from './InternalTaskBoard';
import { ListTodo, CheckCircle, Users, HeartHandshake } from 'lucide-react';

export function HRStaffDashboard() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Human Resource Dashboard</h1>
        <p className="text-muted-foreground">Manage HR tasks, recruitment, and employee relations</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Card>
          <CardContent className="flex items-center gap-4 p-6">
            <div className="h-12 w-12 rounded-xl bg-pink-500/10 flex items-center justify-center">
              <HeartHandshake className="h-6 w-6 text-pink-500" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">HR Department</p>
              <p className="text-lg font-bold">Active</p>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="flex items-center gap-4 p-6">
            <div className="h-12 w-12 rounded-xl bg-orange-500/10 flex items-center justify-center">
              <ListTodo className="h-6 w-6 text-orange-500" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Open Tasks</p>
              <p className="text-lg font-bold">—</p>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="flex items-center gap-4 p-6">
            <div className="h-12 w-12 rounded-xl bg-green-500/10 flex items-center justify-center">
              <CheckCircle className="h-6 w-6 text-green-500" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Completed</p>
              <p className="text-lg font-bold">—</p>
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="flex items-center gap-4 p-6">
            <div className="h-12 w-12 rounded-xl bg-purple-500/10 flex items-center justify-center">
              <Users className="h-6 w-6 text-purple-500" />
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Team Members</p>
              <p className="text-lg font-bold">—</p>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>My Tasks</CardTitle>
        </CardHeader>
        <CardContent>
          <InternalTaskBoard assignedToMe />
        </CardContent>
      </Card>
    </div>
  );
}
